import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useSettlement from './settlement-hooks';
import { SettlementHeader } from './components/settlement-header';
import { SettlementTable } from './components/settlement-table';
import { SettlementViewTabs } from './components/settlement-view-tabs';
import { SettlementBalancingOverview } from './components/settlement-balancing-overview';
import { SettlementLoanFunding } from './components/settlement-loan-funding';

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: '100%',
    margin: 0,
  },
  sideCards: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const Settlement = () => {
  const classes = useStyles();
  const {
    displayedAccounting,
    settlementAccounting,
    allAccounting,
    t,
    isLoading,
    orderId,
    viewMode,
    setViewMode,
    issuesCount,
    balancedCount,
    getPartyDetails,
  } = useSettlement();

  return (
    <Grid container direction="column" spacing={2} className={classes.root}>
      <Grid item xs={12}>
        <SettlementHeader accounting={settlementAccounting} t={t} orderId={orderId} />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={9}>
            <SettlementViewTabs
              viewMode={viewMode}
              onViewModeChange={setViewMode}
              issuesCount={issuesCount}
              balancedCount={balancedCount}
              allCount={settlementAccounting.length}
              t={t}
            />
            <SettlementTable accounting={displayedAccounting} t={t} isLoading={isLoading} getPartyDetails={getPartyDetails} />
          </Grid>
          <Grid item xs={12} md={3} className={classes.sideCards}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <SettlementBalancingOverview accounting={allAccounting} t={t} />
              </Grid>
              <Grid item>
                <SettlementLoanFunding accounting={allAccounting} t={t} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Settlement;
